import { Component, OnInit } from '@angular/core';
import DisableDevtool from 'disable-devtool';
import { Platform, AlertController } from '@ionic/angular';
import { Location } from '@angular/common';
import { App } from '@capacitor/app';
import { filter } from 'rxjs/operators';
import { Router, NavigationEnd } from '@angular/router';

import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { IdleService } from './core/screen-saver/idle.service';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
    isIdle = false;
    showSplash = true;
    currentVersion: string = '';
    checkingUpdate: boolean = false;
    updateAvailable: boolean = false;

    /**
     * Constructor
     */
    constructor(
        public platform: Platform,
        private location: Location,
        public alertController: AlertController,
        private idleService: IdleService,
        private router: Router
    ) {
        this.idleService.onIdle$.subscribe((status) => {
            this.isIdle = status;
        });

        // const fpPromise = FingerprintJS.load({
        //   monitoring: false
        // })
        //   ; (async () => {
        //     // Get the visitor identifier when you need it.
        //     const fp = await fpPromise
        //     const result = await fp.get()
        //     console.log('fingerprint', { 'visitor id': result.visitorId, 'confidence': result.confidence.score })
        //   })()
        if (this.platform.is('android')) {
            this.platform.ready().then(() => {
                this.initializeApp();
                // DisableDevtool({
                //     ondevtoolopen(type, next){
                //         next();
                //     }
                // });}
                 const splashShown = localStorage.getItem('splashShown');
            if (splashShown === 'true') {
                this.showSplash = false; // Skip splash
            } else {
                this.showSplash = true; // Tampilkan splash sekali
            }
            });
        } else if (this.platform.is('ios')) {
            this.platform.ready().then(() => {
                this.initializeApp();
                // DisableDevtool({
                //     ondevtoolopen(type, next){
                //         next();
                //     }
                // });}
                 const splashShown = localStorage.getItem('splashShown');
            if (splashShown === 'true') {
                this.showSplash = false; // Skip splash
            } else {
                this.showSplash = true; // Tampilkan splash sekali
            }
            });
        } else {
            this.platform.ready().then(() => {
                // this.initializeApp()
                // DisableDevtool({
                //     ondevtoolopen(type, next){
                //         next();
                //     }
                // });}
                 const splashShown = localStorage.getItem('splashShown');
            if (splashShown === 'true') {
                this.showSplash = false; // Skip splash
            } else {
                this.showSplash = true; // Tampilkan splash sekali
            }
            });
        }
    }

    ngOnInit() {
        this.initVersionCheck();
    }
    private initVersionCheck() {
        // Ambil versi saat pertama kali load
        this.checkVersion(true);

        // Cek update setiap kali pindah halaman (route change)
        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(() => {
                this.checkVersion(false);
            });

        // Cek saat user kembali ke tab PWA / Web Browser
        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'visible') {
                this.checkVersion(false);
            }
        });

        // Cek saat user kembali ke aplikasi via Capacitor (Android/iOS)
        App.addListener('appStateChange', (state) => {
            if (state.isActive) {
                this.checkVersion(false);
            }
        });

        // Cek secara berkala setiap 15 menit jika user stay di 1 halaman
        setInterval(() => {
            this.checkVersion(false);
        }, 15 * 60 * 1000);
    }

    private async checkVersion(isInitialLoad: boolean) {
        if (this.checkingUpdate) return;
        this.checkingUpdate = true;

        try {
            // Tambah query string agar browser tidak mengambil dari cache
            const cacheBuster = new Date().getTime();
            const response = await fetch(`/assets/version.json?t=${cacheBuster}`, {
                cache: 'no-store',
                headers: { 'Cache-Control': 'no-cache', 'Pragma': 'no-cache' }
            });
            const data = await response.json();

            const serverVersion = String(data.version); // pastikan selalu string
            const savedVersion = localStorage.getItem('appVersion');

            if (!savedVersion) {
                // Pertama kali buka aplikasi selamanya
                localStorage.setItem('appVersion', serverVersion);
                this.currentVersion = serverVersion;
            } else {
                this.currentVersion = savedVersion;
                // Bandingkan jika ada versi yang beda di server
                if (serverVersion !== this.currentVersion) {
                    this.currentVersion = serverVersion;
                    localStorage.setItem('appVersion', serverVersion); // Simpan versi baru agar tidak terus-terusan muncul
                    this.promptUserToUpdate();
                }
            }
        } catch (err) {
            console.error('Error checking version', err);
        } finally {
            this.checkingUpdate = false;
        }
    }

    async promptUserToUpdate() {
        this.updateAvailable = true;
    }

    async reloadApp() {
        try {
            // Bersihkan semua CacheStorage (bekas Service Worker atau cache lainnya)
            if ('caches' in window) {
                const keys = await caches.keys();
                await Promise.all(keys.map(k => caches.delete(k)));
            }
            // Unregister Service Worker jika masih ada (safety net)
            if ('serviceWorker' in navigator) {
                const regs = await navigator.serviceWorker.getRegistrations();
                await Promise.all(regs.map(r => r.unregister()));
            }
        } catch (e) {
            console.warn('Failed to clear cache before reload:', e);
        }
        // Reload dengan cache-buster query param supaya browser paksa fetch
        // index.html yang fresh dari server (bypass HTTP cache untuk HTML).
        const url = new URL(window.location.href);
        url.searchParams.set('_v', Date.now().toString());
        window.location.replace(url.toString());
    }

    initializeApp() {
        App.addListener('backButton', async () => {
            let route = this.location.path();
            if (route.includes('sign-in') || route.includes('home')) {
                await this.showExitConfirm();
            } else {
                this.location.back();
            }
        });
    }
    async showExitConfirm() {
        const alert = await this.alertController.create({
            header: 'App termination',
            message: 'Do you want to close the app?',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {},
                },
                {
                    text: 'Exit',
                    handler: () => {
                        App.exitApp();
                    },
                },
            ],
        });
        await alert.present();
    }
    onSplashFinished() {
        console.log('🎬 Splash finished event received');
        this.showSplash = false;
        console.log('showSplash sekarang:', this.showSplash);
         // 🔹 Tandai bahwa splash sudah pernah ditampilkan
        localStorage.setItem('splashShown', 'true');
    }
}
